var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntegrationIcon = function SvgIntegrationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#integration_icon_svg__a)",
    d: "M17.657 29.815a4.502 4.502 0 1 1-3.157-.06v-9.51a4.502 4.502 0 1 1 3 0V25a7.46 7.46 0 0 1 4.5-1.5h6a4.5 4.5 0 0 0 4.342-3.315 4.502 4.502 0 1 1 3.048.096 7.5 7.5 0 0 1-7.39 6.22h-6a4.5 4.5 0 0 0-4.343 3.314M16 32.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0-18a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m18 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "integration_icon_svg__a",
    x1: 11.497,
    x2: 38.501,
    y1: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D52F4",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D52F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D52F4",
    stopOpacity: 0.8
  })))));
};
export default SvgIntegrationIcon;